// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import { HandsOnCompletionStatusType } from '../../types/Model';
import S from './styles';
import { FormattedMessage } from 'react-intl';

const CompletionStatusTag:React.FC<{ type: HandsOnCompletionStatusType, score?: number }> = ({ type, score, ...props }):JSX.Element | null => {
  switch (type) {
    case HandsOnCompletionStatusType.ENDED:
      return <S.EndedContainer {...props}><S.TickIcon /><FormattedMessage id="B049"/></S.EndedContainer>
    case HandsOnCompletionStatusType.COMPLETED:
      if (score !== undefined) {
        return <S.CompletedWithScoreContainer {...props}>{score} %</S.CompletedWithScoreContainer>
      } else {
        return <S.CompletedContainer {...props}><S.TickIcon /><FormattedMessage id="B033"/></S.CompletedContainer>
      }
    case HandsOnCompletionStatusType.REVIEWING:
      return <S.EndedContainer {...props}><S.UntickIcon /><FormattedMessage id="B048"/></S.EndedContainer>
    case HandsOnCompletionStatusType.COMPLETED_PASS:
      return <S.CompletedContainer {...props}><S.TickIcon /><FormattedMessage id="B046"/></S.CompletedContainer>
    case HandsOnCompletionStatusType.COMPLETED_NO_PASS:
      return <S.FailedContainer {...props}><S.CrossIcon /><FormattedMessage id="B047"/></S.FailedContainer>
    case HandsOnCompletionStatusType.INCOMPLETE:
      return <S.IncompleteContainer {...props}><S.UntickIcon /><FormattedMessage id="B035"/></S.IncompleteContainer>
    case HandsOnCompletionStatusType.REVIEWED:
      return <S.CompletedContainer {...props}><S.TickIcon /><FormattedMessage id="B054"/></S.CompletedContainer>
    case HandsOnCompletionStatusType.NOREVIEW:
      return <S.IncompleteContainer {...props}><S.UntickIcon /><FormattedMessage id="B055"/></S.IncompleteContainer>
    default:
      return null;
  }
}

export { CompletionStatusTag as default};
